import styled from 'styled-components';
import Button from '../../../../../../../components/Atoms/Button/Button';
import { Popup } from '../../styled/Popup.styled';
export const VisitorPopup = styled(Popup) `
  width: 272px;
  right: -45px;
`;
export const SignInButton = styled(Button) `
  width: 100%;
`;
export const SignUpParagraph = styled.p `
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  padding: 12px 12px 0 12px;
`;
export const SignUpLink = styled.a `
  color: ${({ theme }) => theme.colors.interactivePrimary01};
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
`;
//# sourceMappingURL=VisitorPopup.styled.js.map